import { preload } from "../include/module";
preload();

import { anchorLink } from "../include/module";
anchorLink();

import { toggleNav } from "../include/module";
toggleNav();

import { toggleProf } from "../include/module";
toggleProf();

import { toggleMovie } from "../include/module";
toggleMovie();

import { animeScroll } from "../include/module";
animeScroll();

import { animeLoad } from "../include/module";
animeLoad();



// WEBPACK FOOTER //
// ./src/assets/js/next/script.js